module.exports = __webpack_public_path__ + "public/images/icon-telegram.09b863f5c00ccd9fbaa42dd21b81e06b.svg";